import { api } from '../client'
import { ENDPOINTS } from '../config'

export interface AlternativeContactRecord {
    _id: string
    title?: string
    firstName: string
    middleName?: string
    lastName: string
    phoneNumber: string
    address?: string
    city?: string
    state?: string
    country?: string
    picture?: string
    children?: Array<{
        _id: string
        firstName: string
        middleName?: string
        lastName: string
        dateOfBirth?: string
    }>
}

export interface CreateAlternativeContactPayload {
    title?: string
    firstName: string
    middleName?: string
    lastName: string
    phoneNumber: string
    address: string
    city: string
    state: string
    country: string
    picture: string
    children?: string[]
}

export const AlternativeContactsService = {
    byParent: (parentId: string) =>
        api.get<AlternativeContactRecord[]>(
            ENDPOINTS.ALTERNATIVE_CONTACTS.BY_PARENT(parentId)
        ),

    create: (payload: CreateAlternativeContactPayload) =>
        api.post<AlternativeContactRecord>(
            ENDPOINTS.ALTERNATIVE_CONTACTS.CREATE,
            payload
        ),

    update: (id: string, payload: Partial<CreateAlternativeContactPayload>) =>
        api.patch<AlternativeContactRecord>(
            ENDPOINTS.ALTERNATIVE_CONTACTS.UPDATE(id),
            payload
        ),

    remove: (id: string) =>
        api.delete<{ success?: boolean; message?: string }>(
            ENDPOINTS.ALTERNATIVE_CONTACTS.DELETE(id)
        )
}
